export const statusOptions = [
  {
    label: 'client_feedback',
    value: 1
  },
  {
    label: 'after_sales',
    value: 2
  },
  {
    label: 'quality_inspection',
    value: 3
  },
  {
    label: 'repair_processing',
    value: 4
  },
  {
    label: 'line_handling',
    value: 5
  },
  {
    label: 'pmc_handling',
    value: 6
  },
  {
    label: 'finish',
    value: 100
  },
  {
    label: 'scrapped',
    value: 101
  }
]


export const problemTypes = [
  {
    label: 'incoming',
    value: 1
  },
  {
    label: 'production',
    value: 2
  },
  {
    label: 'dev_design',
    value: 3
  },
  {
    label: 'client',
    value: 4
  },
  {
    label: 'other',
    value: 100
  },
]